import { observer } from 'mobx-react';
import { useForm } from 'react-hook-form';

import { QlService, QlType } from 'lib/apis/entity/ql';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { usePlpStore } from '../../../DataStore';

type Form = QlType.DirectSaveSearch;

interface Props {
  closeModal?: () => void;
}

function SaveSearchDirectAssign({ closeModal }: Props) {
  const { t } = useOwnTranslate('');
  const { saveSearchCreate } = usePlpStore();
  const { register, handleSubmit } = useForm<Form>({
    defaultValues: {
      description: saveSearchCreate?.description || "",
      budgetStatus: saveSearchCreate?.budgetStatus || "OTHER",
      title: saveSearchCreate.title,
    },
  });
  const { mutate, isLoading, isSuccess } =
    QlService.CreateSaveSearchDirect.useMutation((data) => {
      if(data?.error){
        toast.error(data.error.msg);
      }
      else {
        toast.success("ذخیره شد.");
      }
    });
  const submit = ({ title, budgetStatus, description }: Form) => {
    let body: QlType.DirectSaveSearch = {
      title: title,
      content: saveSearchCreate.content,
      description: description,
      budgetStatus: budgetStatus,
      source: "PLP"
    }

    mutate(body);
  };
  useEffect(() => {
    if (isSuccess && closeModal) closeModal!();
  }, [isSuccess]);


  return (
    <>
      <div className="p-4 lg:w-[420px] w-[300px]">
        <div className="mb-4">
          <p className="text-lg text-semiBold">
            یافتن ملک از طریق مشاورین املاک
          </p>
          <p className="text-grey-600">جستجوی من را به مشاورین بسپار</p>
        </div>
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(submit)}>
          <div className="form-group">
            <label>عنوان</label>
            <input type="text" {...register('title', { required: true })} />
          </div>
          <div className="form-group">
            <label>نوع معامله</label>
            <select className="pr-4" {...register('budgetStatus', { required: true })}>
              <option value="OTHER">سایر</option>
              <option value="CASH">نقدی</option>
              <option value="ASSET">معاوضه</option>
            </select>
            {/*<label htmlFor="CASH" className="cursor-pointer grow">*/}
            {/*  <input {...register('budgetStatus', { required: true })}*/}
            {/*    className="sr-only peer"*/}
            {/*    value="CASH"*/}
            {/*    id="CASH"*/}
            {/*    type="radio"*/}
            {/*  />*/}
            {/*  <span className="flex justify-center w-full btn-group peer-checked:btn-group--active">*/}
            {/*    نقدی*/}
            {/*  </span>*/}
            {/*</label>*/}
            {/*<label htmlFor="ASSET" className="cursor-pointer grow">*/}
            {/*  <input {...register('budgetStatus', { required: true })}*/}
            {/*    className="sr-only peer"*/}
            {/*    value="ASSET"*/}
            {/*    id="ASSET"*/}
            {/*    type="radio"*/}
            {/*  />*/}
            {/*  <span className="flex justify-center w-full btn-group peer-checked:btn-group--active">*/}
            {/*    معاوضه*/}
            {/*  </span>*/}
            {/*</label>*/}
            {/*<label htmlFor="OTHER" className="cursor-pointer grow">*/}
            {/*  <input {...register('budgetStatus', { required: true })}*/}
            {/*    className="sr-only peer"*/}
            {/*    value="OTHER"*/}
            {/*    id="OTHER"*/}
            {/*    type="radio"*/}
            {/*  />*/}
            {/*  <span className="flex justify-center w-full btn-group peer-checked:btn-group--active">*/}
            {/*    سایر*/}
            {/*  </span>*/}
            {/*</label>*/}
          </div>
          <div className="form-group">
            <label>توضیحات</label>
            <textarea
              {...register('description', { required: true })}
              rows={4}
            />
          </div>

          <div className="flex flex-row items-center justify-center gap-4">
            <button
              className="w-full btn btn-grey-outline"
              type="button"
              disabled={isLoading}
              onClick={closeModal}
            >
              {t('global.cancel')}
            </button>
            <button
              className="w-full btn btn-primary"
              type="submit"
              disabled={isLoading}
            >
              {t('global.accept')}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default observer(SaveSearchDirectAssign);
